import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { route } from 'preact-router';

import style from './style.css';

function isConsumerWeb(cat) {
    if (cat.showOnConsumerWeb) {
        return (
            <small>
                <span class='badge'>cw</span>
            </small>
        );
    }
    return '';
}

function isDealerWeb(cat) {
    if (cat.status === 2) {
        return (
            <small>
                <span class='badge'>dw</span>
            </small>
        );
    }
    return '';
}

const initialState = {};

@observer
class CategoryBranch extends Component {
    constructor(props) {
        super(props);
        this.state = { ...initialState };
    }

    render(props = this.props) {
        const { categoryStore, productStore } = props.stores;
        const { categoryTree, categoryView } = categoryStore;
        const { queryFilter, toggleQueryfilter } = productStore;

        const filterRegexp = new RegExp(`^${props.brand}`, 'i');
        return (
            <div class='ml-4'>
                {categoryTree.filter(e => e.name.match(filterRegexp)).map((cat) => {
                    const isSelectedMain = cat.groupno == queryFilter.mainCat;
                    const onClickMain = () => {
                        toggleQueryfilter('intCat', '', { setValue: 1, skipUpdate: 1 });
                        toggleQueryfilter('subCat', '', { setValue: 1, skipUpdate: 1 });
                        toggleQueryfilter('mainCat', cat.groupno, {
                            setValue: 1,
                            // toggle: groupno => categoryStore.updateCategoryView(cat.groupno, groupno == cat.groupno ? 1 : null),
                        });
                        route(`/products/`, true);
                    };
                    const onClickRemoveMain = (e) => {
                        e.stopPropagation();
                        toggleQueryfilter('mainCat', '', { setValue: 1 });
                        categoryStore.updateCategoryView(cat.groupno, null);
                        route(`/products/`, true);
                    };
                    const toggleMain = (e) => {
                        e.stopPropagation();
                        categoryStore.updateCategoryView(cat.groupno);
                    };
                    const hasChildrenMain = cat.children && cat.children.length > 0;
                    return (
                        <div class='nav-item'>
                            <div class={`${style.pointerCursor} nav-link py-0 ${isSelectedMain ? 'active' : ''}`}>
                                <span onClick={onClickMain}>
                                    <i class={`${hasChildrenMain ? 'fas' : 'far'} fa-folder${categoryView[cat.groupno] ? '-open' : ''} mr-1`} onClick={toggleMain} />
                                    {cat.name} {isConsumerWeb(cat)} {isDealerWeb(cat)}
                                    {cat.count && <span class='font-weight-lighter float-right'>({cat.count})</span>}
                                </span>
                                {isSelectedMain && <span class={`${style.pointerCursor} float-right`}>
                                    <i class='fas fa-times-circle float-right mt-1' onClick={onClickRemoveMain} />
                                </span>}
                            </div>
                            <div class={`d-${categoryView[cat.groupno] ? 'block' : 'none'} nav flex-column mt-1`}>
                                {hasChildrenMain && cat.children.map((intcat) => {
                                    const isSelectedInt = intcat.groupno == queryFilter.intCat;
                                    const onClickInt = () => {
                                        toggleQueryfilter('mainCat', '', { setValue: 1, skipUpdate: 1 });
                                        toggleQueryfilter('subCat', '', { setValue: 1, skipUpdate: 1 });
                                        toggleQueryfilter('intCat', intcat.groupno, {
                                            setValue: 1,
                                            // toggle: groupno => categoryStore.updateCategoryView(intcat.groupno, groupno == intcat.groupno ? 1 : null),
                                        });
                                        route(`/products/`, true);
                                    };
                                    const onClickRemoveInt = (e) => {
                                        e.stopPropagation();
                                        toggleQueryfilter('intCat', '', { setValue: 1 });
                                        categoryStore.updateCategoryView(intcat.groupno, null);
                                        route(`/products/`, true);
                                    };
                                    const toggleInt = (e) => {
                                        e.stopPropagation();
                                        categoryStore.updateCategoryView(intcat.groupno);
                                    };
                                    const hasChildrenInt = intcat.children && intcat.children.length > 0;
                                    return (
                                        <div class='ml-4 font-weight-lighter'>
                                            <div class={`${style.pointerCursor} nav-link py-0 ${isSelectedInt ? 'active' : ''}`}>
                                                {isSelectedInt && <span class={style.pointerCursor}>
                                                    <i class='fas fa-times-circle float-right mt-1' onClick={onClickRemoveInt} />
                                                </span>}
                                                <span onClick={onClickInt}>
                                                    <i class={`${hasChildrenInt ? 'fas' : 'far'} fa-folder${categoryView[intcat.groupno] ? '-open' : ''} mr-1`} onClick={toggleInt} />
                                                    {intcat.name} {isConsumerWeb(intcat)} {isDealerWeb(intcat)}
                                                    {intcat.count && <span class='font-weight-lighter float-right'>({intcat.count})</span>}
                                                </span>
                                            </div>
                                            <div class={`d-${categoryView[intcat.groupno] ? 'block' : 'none'} nav flex-column mt-1`}>
                                                {hasChildrenInt && intcat.children.map((subcat) => {
                                                    const isSelectedSub = subcat.groupno == queryFilter.subCat;
                                                    const onClickSub = () => {
                                                        toggleQueryfilter('mainCat', '', { setValue: 1, skipUpdate: 1 });
                                                        toggleQueryfilter('intCat', '', { setValue: 1, skipUpdate: 1 });
                                                        toggleQueryfilter('subCat', subcat.groupno, {
                                                            setValue: 1,
                                                            // toggle: () => categoryStore.updateCategoryView(subcat.groupno, (!isSelectedInt && categoryView[subcat.groupno] ? 1 : null)),
                                                        });
                                                        route(`/products/`, true);
                                                    };
                                                    const onClickRemoveSub = (e) => {
                                                        e.stopPropagation();
                                                        toggleQueryfilter('subCat', '', { setValue: 1 });
                                                        categoryStore.updateCategoryView(subcat.groupno, null);
                                                        route(`/products/`, true);
                                                    };
                                                    return (
                                                        <div class='ml-4 font-weight-lighter'>
                                                            <div class={`${style.pointerCursor} nav-link py-0 ${isSelectedSub ? 'active' : ''}`}>
                                                                {isSelectedSub && <span class={style.pointerCursor}>
                                                                    <i class='fas fa-times-circle float-right mt-1' onClick={onClickRemoveSub} />
                                                                </span>}
                                                                <span onClick={onClickSub}>
                                                                    <i class={`far fa-folder${categoryView[subcat.groupno] ? '-open' : ''} mr-1`} />
                                                                    {subcat.name} {isConsumerWeb(subcat)} {isDealerWeb(subcat)}
                                                                    {subcat.count && <span class='font-weight-lighter float-right'>({subcat.count})</span>}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default CategoryBranch;



// WEBPACK FOOTER //
// ./components/products/treeBranch.js